import { Link } from 'react-router-dom'
import { ButtonLink } from '@/components/ui/ButtonLink'
import { StartClubCta } from '@/components/marketing/StartClubCta'
import styles from './HomeDoors.module.css'

const WORKSPACE_ROUTE = '/workspace'
const DEMO_CLUB_ROUTE = '/clubs/point-racket-club-and-academy'

/**
 * The two doors under the hero (docs/ux/2026-09-23-home-doors-two-plus-links.md §4):
 * Door 1 is the business door — club, coach and organizer alike, since its
 * audience is three of the pricing ladder's tiers, not one. Coach and organizer
 * get a worded presence as self-identify chip links to their pricing tier,
 * rather than their own cards. Door 2 is the player door: its button is Sign in,
 * because a player his club already added comes here to sign in, not to find a
 * club (docs/ux/2026-10-20-home-player-entry.md §3 A, shipped with D). Headings
 * are h2 — the page keeps exactly one H1. Every action is a real link a
 * crawler can follow.
 */
export function HomeDoors() {
  return (
    <div className={styles.doors}>
      <section className={styles.door} aria-labelledby="home-door-club" data-enter="left">
        <h2 id="home-door-club" className={styles.title}>
          I run a club or program
        </h2>
        <p className={styles.body}>
          Court bookings, coaching, tournaments and memberships — all in one place.
        </p>
        <div className={styles.cta}>
          <StartClubCta source="home_hero" size="lg" to={WORKSPACE_ROUTE} className={styles.glow}>
            Start free
          </StartClubCta>
          <Link to={DEMO_CLUB_ROUTE} className={styles.quiet}>
            See a live club →
          </Link>
        </div>
        <div className={styles.identify}>
          <Link to="/pricing#plan-coach" className={styles.chip}>
            I'm a coach
          </Link>
          <Link to="/pricing#plan-organizer" className={styles.chip}>
            I organize tournaments
          </Link>
        </div>
        <p className={styles.fine}>No card required.</p>
      </section>

      <section className={styles.door} aria-labelledby="home-door-player" data-enter="right">
        <h2 id="home-door-player" className={styles.title}>
          I play
        </h2>
        <p className={styles.body}>Book a court, enter tournaments, get rated.</p>
        <div className={styles.cta}>
          <ButtonLink size="lg" variant="secondary" to="/login">
            Sign in
          </ButtonLink>
          <Link to="/clubs" className={styles.quiet}>
            Find a club →
          </Link>
        </div>
        <p className={styles.fine}>
          <Link to="/tournaments" className={styles.quiet}>
            Browse tournaments →
          </Link>
        </p>
      </section>
    </div>
  )
}
